import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectRole} from "../../slices/profile";
import {PrivateRoute} from "../../routes/private";
import Toolbar from "../../components/Toolbar/main";
import StudentPrivate from "../StudentPrivate";
import {ROUTES} from "../../db/models/const";
import CompanyPrivate from "../CompanyPrivate/Private";
import {RoleEnum} from "../../db/models/role";
import SchoolPrivate from "../SchoolPrivate/main";
import {Alert, Button} from "react-bootstrap";
import {Logout} from "../../api/auth";

interface Props {
    topRef: any;
}

const UserPrivate: React.FC<Props> = ({topRef}) => {
    const role = useSelector(selectRole);
    const dispatch = useDispatch();

    const onLogout = () => {
        return Logout(dispatch);
    }

    return (
        <>
            {role === RoleEnum.Student && (
                <PrivateRoute path={ROUTES.ME}>
                    <Toolbar/>
                    <StudentPrivate topRef={topRef}/>
                </PrivateRoute>
            )}
            {role === RoleEnum.Company && (
                <PrivateRoute path={ROUTES.ME}>
                    <Toolbar/>
                    <CompanyPrivate/>
                </PrivateRoute>
            )}
            {role === RoleEnum.School && (
                <PrivateRoute path={ROUTES.ME}>
                    <Toolbar/>
                    <SchoolPrivate/>
                </PrivateRoute>
            )}
            {role === RoleEnum.Tutor && (
                <PrivateRoute path={ROUTES.ME}>
                    <Toolbar/>
                    {/*Tutor component removed from here*/}
                </PrivateRoute>
            )}
            {role === RoleEnum.Admin && (
                <div className={"container"}>
                    <Alert variant="danger">Permission denied</Alert>
                    <Button className={""} onClick={() => onLogout()}>Logout</Button>
                </div>
            )}
        </>
    );
};

export default UserPrivate;
